import * as React from "react";

import "./Checkbox.scss";

const Checkbox = (props) => {
  const { id, label, onChange, isChecked, ...rest } = props;

  const [isCheckedCheckbox, setIsCheckedCheckbox] = React.useState(!!isChecked);

  const inputId = id || `checkbox-${Math.floor(Math.random() * 1000)}`;

  React.useEffect(() => {
    setIsCheckedCheckbox(!!isChecked);
  }, [isChecked]);

  const onChangeValue = (e) => {
    setIsCheckedCheckbox((prev) => !prev);
    onChange?.(e);
  };

  return (
    <label className="custom-checkbox" htmlFor={inputId}>
      <span className="caption-checkbox">{label}</span>
      <input
        id={inputId}
        checked={isCheckedCheckbox}
        onChange={onChangeValue}
        {...rest}
        type="checkbox"
      />
      <span className="checkmark"></span>
    </label>
  );
};

export default Checkbox;
